import * as api from '@api/conference';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'CONFERENCE';

export const FETCH_CODE_FILE = createRequestTypes(
  `${prefix}/FETCH_CODE_FILE`,
);

export const fetchCodeFile = makeApiActionCreatorV3(
  api.fetchCodeFile,
  FETCH_CODE_FILE[START],
  FETCH_CODE_FILE[SUCCESS],
  FETCH_CODE_FILE[ERROR],
);

export const FETCH_CHIME_CONFERENCE = createRequestTypes(
  `${prefix}/FETCH_CHIME_CONFERENCE`,
);

export const fetchChimeConference = makeApiActionCreatorV3(
  api.fetchChimeConference,
  FETCH_CHIME_CONFERENCE[START],
  FETCH_CHIME_CONFERENCE[SUCCESS],
  FETCH_CHIME_CONFERENCE[ERROR],
);

export const CREATE_CONFERENCE = createRequestTypes(
  `${prefix}/CREATE_CONFERENCE`,
);

export const createChimeConference = makeApiActionCreatorV3(
  api.createChimeConference,
  CREATE_CONFERENCE[START],
  CREATE_CONFERENCE[SUCCESS],
  CREATE_CONFERENCE[ERROR],
);

export const SET_ACTIVE_CONFERENCE = `${prefix}/SET_ACTIVE_CONFERENCE`;

export const setActiveConference = conference => ({
  type: SET_ACTIVE_CONFERENCE,
  payload: conference,
});

export const SET_CONFERENCE_META = `${prefix}/SET_CONFERENCE_META`;

export const setConferenceMeta = metaData => ({
  type: SET_CONFERENCE_META,
  payload: metaData,
});

export const JOIN_CHIME_CONFERENCE = createRequestTypes(
  `${prefix}/JOIN_CHIME_CONFERENCE`,
);

export const joinChimeConference = makeApiActionCreatorV3(
  api.joinChimeConference,
  JOIN_CHIME_CONFERENCE[START],
  JOIN_CHIME_CONFERENCE[SUCCESS],
  JOIN_CHIME_CONFERENCE[ERROR],
);

export const END_CHIME_CONFERENCE = createRequestTypes(
  `${prefix}/END_CHIME_CONFERENCE`,
);

export const endChimeConference = makeApiActionCreatorV3(
  api.endChimeConference,
  END_CHIME_CONFERENCE[START],
  END_CHIME_CONFERENCE[SUCCESS],
  END_CHIME_CONFERENCE[ERROR],
);

export const END_APPEAL_PANEL_CONFERENCE = createRequestTypes(
  `${prefix}/END_APPEAL_PANEL_CONFERENCE`,
);

export const endAppealPanelConference = makeApiActionCreatorV3(
  api.endAppealPanelConference,
  END_APPEAL_PANEL_CONFERENCE[START],
  END_APPEAL_PANEL_CONFERENCE[SUCCESS],
  END_APPEAL_PANEL_CONFERENCE[ERROR],
);

export const DIAL_OUT = createRequestTypes(
  `${prefix}/DIAL_OUT`,
);

export const dialOut = makeApiActionCreatorV3(
  api.dialOut,
  DIAL_OUT[START],
  DIAL_OUT[SUCCESS],
  DIAL_OUT[ERROR],
);

export const FETCH_ATTENDEES = createRequestTypes(
  `${prefix}/FETCH_ATTENDEES`,
);

export const fetchAttendees = makeApiActionCreatorV3(
  api.fetchAttendees,
  FETCH_ATTENDEES[START],
  FETCH_ATTENDEES[SUCCESS],
  FETCH_ATTENDEES[ERROR],
);

export const FETCH_ATTENDEE_BY_ID = createRequestTypes(
  `${prefix}/FETCH_ATTENDEE_BY_ID`,
);

export const fetchAttendeeById = makeApiActionCreatorV3(
  api.fetchAttendeeById,
  FETCH_ATTENDEE_BY_ID[START],
  FETCH_ATTENDEE_BY_ID[SUCCESS],
  FETCH_ATTENDEE_BY_ID[ERROR],
);

export const REMOVE_ATTENDEE_FROM_CONFERENCE = createRequestTypes(
  `${prefix}/REMOVE_ATTENDEE_FROM_CONFERENCE`,
);

export const removeAttendeeFromConference = makeApiActionCreatorV3(
  api.removeAttendeeFromConference,
  REMOVE_ATTENDEE_FROM_CONFERENCE[START],
  REMOVE_ATTENDEE_FROM_CONFERENCE[SUCCESS],
  REMOVE_ATTENDEE_FROM_CONFERENCE[ERROR],
);

export const UPDATE_ATTENDEE_CAPABILITIES = createRequestTypes(
  `${prefix}/UPDATE_ATTENDEE_CAPABILITIES`,
);

export const updateAttendeeCapabilities = makeApiActionCreatorV3(
  api.updateAttendeeCapabilities,
  UPDATE_ATTENDEE_CAPABILITIES[START],
  UPDATE_ATTENDEE_CAPABILITIES[SUCCESS],
  UPDATE_ATTENDEE_CAPABILITIES[ERROR],
);

export const FETCH_SUPPORT_CALL_IN_NUMBER = createRequestTypes(
  `${prefix}/FETCH_SUPPORT_CALL_IN_NUMBER`,
);

export const fetchSpportCallInNumber = makeApiActionCreatorV3(
  api.fetchSpportCallInNumber,
  FETCH_SUPPORT_CALL_IN_NUMBER[START],
  FETCH_SUPPORT_CALL_IN_NUMBER[SUCCESS],
  FETCH_SUPPORT_CALL_IN_NUMBER[ERROR],
);

export const SET_AWS_CHIMES_DATA = `${prefix}/SET_AWS_CHIMES_DATA`;

export const setAWSChimesMeeting = (data) => {
  return async dispatch => {
    dispatch({ type: SET_AWS_CHIMES_DATA, data });
  }
};

export const UPDATE_MEETING_ATTENDEE_INFO = `${prefix}/UPDATE_MEETING_ATTENDEE_INFO`;

export const updateMeetingAttendeeInfo = (data) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_MEETING_ATTENDEE_INFO, data });
  };
};

export const ADD_AWS_CHIMES_CHAT = `${prefix}/ADD_AWS_CHIMES_CHAT`;

export const addAWSChimesChat = (data) => {
  return async dispatch => {
    dispatch({ type: ADD_AWS_CHIMES_CHAT, data });
  }
}

export const INIT_AWS_CHIMES_CHAT = `${prefix}/INIT_AWS_CHIMES_CHAT`;

export const initAWSChimesChat = (data) => {
  return async dispatch => {
    dispatch({ type: INIT_AWS_CHIMES_CHAT, data });
  }
}

export const FETCH_PERMISSION_CHECKS = createRequestTypes(
  `${prefix}/FETCH_PERMISSION_CHECKS`,
);

export const fetchPermissionChecks = makeApiActionCreatorV3(
  api.fetchPermissionChecks,
  FETCH_PERMISSION_CHECKS[START],
  FETCH_PERMISSION_CHECKS[SUCCESS],
  FETCH_PERMISSION_CHECKS[ERROR],
);

export const START_RECORDING = createRequestTypes(
  `${prefix}/START_RECORDING`,
);

export const startRecording = makeApiActionCreatorV3(
  api.startRecording,
  START_RECORDING[START],
  START_RECORDING[SUCCESS],
  START_RECORDING[ERROR],
);

export const START_HEARING = createRequestTypes(
  `${prefix}/START_HEARING`,
);

export const startHearing = makeApiActionCreatorV3(
  api.startHearing,
  START_HEARING[START],
  START_HEARING[SUCCESS],
  START_HEARING[ERROR],
);

export const START_HEARING_INFORMAL = createRequestTypes(
  `${prefix}/START_HEARING_INFORMAL`,
);

export const startHearingInformal = makeApiActionCreatorV3(
  api.startHearingInformal,
  START_HEARING_INFORMAL[START],
  START_HEARING_INFORMAL[SUCCESS],
  START_HEARING_INFORMAL[ERROR],
);

export const START_RECORDING_APPEAL = createRequestTypes(
  `${prefix}/START_RECORDING_APPEAL`,
);

export const startRecordingAppeal = makeApiActionCreatorV3(
  api.startRecordingAppeal,
  START_RECORDING_APPEAL[START],
  START_RECORDING_APPEAL[SUCCESS],
  START_RECORDING_APPEAL[ERROR],
);

export const END_RECORDING = createRequestTypes(
  `${prefix}/END_RECORDING`,
);

export const END_HEARING = createRequestTypes(
  `${prefix}/END_HEARING`,
);

export const endHearing = makeApiActionCreatorV3(
  api.endHearing,
  END_HEARING[START],
  END_HEARING[SUCCESS],
  END_HEARING[ERROR],
);

export const END_HEARING_INFORMAL = createRequestTypes(
  `${prefix}/END_HEARING_INFORMAL`,
);

export const endHearingInformal = makeApiActionCreatorV3(
  api.endHearingInformal,
  END_HEARING_INFORMAL[START],
  END_HEARING_INFORMAL[SUCCESS],
  END_HEARING_INFORMAL[ERROR],
);

export const endRecording = makeApiActionCreatorV3(
  api.endRecording,
  END_RECORDING[START],
  END_RECORDING[SUCCESS],
  END_RECORDING[ERROR],
);

export const END_APPEAL_RECORDING = createRequestTypes(
  `${prefix}/END_APPEAL_RECORDING`,
);

export const endAppealRecording = makeApiActionCreatorV3(
  api.endAppealRecording,
  END_APPEAL_RECORDING[START],
  END_APPEAL_RECORDING[SUCCESS],
  END_APPEAL_RECORDING[ERROR],
);
export const DOWNLOAD_CONFERENCE_RECORDING = createRequestTypes(
  `${prefix}/DOWNLOAD_CONFERENCE_RECORDING`,
);

export const downloadConferenceRecording = makeApiActionCreatorV3(
  api.downloadConferenceRecording,
  DOWNLOAD_CONFERENCE_RECORDING[START],
  DOWNLOAD_CONFERENCE_RECORDING[SUCCESS],
  DOWNLOAD_CONFERENCE_RECORDING[ERROR],
);

export const FETCH_CURRENT_CONFERENCES = createRequestTypes(
  `${prefix}/FETCH_CURRENT_CONFERENCES`,
);

export const fetchCurrentConferences = makeApiActionCreatorV3(
  api.fetchCurrentConferences,
  FETCH_CURRENT_CONFERENCES[START],
  FETCH_CURRENT_CONFERENCES[SUCCESS],
  FETCH_CURRENT_CONFERENCES[ERROR],
);

export const FETCH_PAST_CONFERENCES = createRequestTypes(
  `${prefix}/FETCH_PAST_CONFERENCES`,
);

export const fetchPastConferences = makeApiActionCreatorV3(
  api.fetchPastConferences,
  FETCH_PAST_CONFERENCES[START],
  FETCH_PAST_CONFERENCES[SUCCESS],
  FETCH_PAST_CONFERENCES[ERROR],
);

export const FETCH_CURRENT_HELP_SESSIONS = createRequestTypes(
  `${prefix}/FETCH_CURRENT_HELP_SESSIONS`,
);

export const fetchCurrentHelpSessions = makeApiActionCreatorV3(
  api.fetchCurrentHelpSessions,
  FETCH_CURRENT_HELP_SESSIONS[START],
  FETCH_CURRENT_HELP_SESSIONS[SUCCESS],
  FETCH_CURRENT_HELP_SESSIONS[ERROR],
);

export const FETCH_PAST_HELP_SESSIONS = createRequestTypes(
  `${prefix}/FETCH_PAST_HELP_SESSIONS`,
);

export const fetchPastHelpSessions = makeApiActionCreatorV3(
  api.fetchPastHelpSessions,
  FETCH_PAST_HELP_SESSIONS[START],
  FETCH_PAST_HELP_SESSIONS[SUCCESS],
  FETCH_PAST_HELP_SESSIONS[ERROR],
);

export const FETCH_ATTENDEE_HISTORY = createRequestTypes(
  `${prefix}/FETCH_ATTENDEE_HISTORY`,
);

export const fetchAttendeeHistory = makeApiActionCreatorV3(
  api.fetchAttendeeHistory,
  FETCH_ATTENDEE_HISTORY[START],
  FETCH_ATTENDEE_HISTORY[SUCCESS],
  FETCH_ATTENDEE_HISTORY[ERROR],
);

export const SEND_MEETING_INFO = createRequestTypes(
  `${prefix}/SEND_MEETING_INFO`,
);

export const sendMeetingInfo = makeApiActionCreatorV3(
  api.sendMeetingInfo,
  SEND_MEETING_INFO[START],
  SEND_MEETING_INFO[SUCCESS],
  SEND_MEETING_INFO[ERROR],
);

export const CHANGE_PAGE = `${prefix}/CHANGE_PAGE`;

export const changePage = page => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const CHANGE_ROWS_PER_PAGE = `${prefix}/CHANGE_ROWS_PER_PAGE`;

export const changeRowsPerPage = rowsPerPage => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const CHANGE_PAGE_PAST = `${prefix}/CHANGE_PAGE_PAST`;

export const changePastPage = page => ({
  type: CHANGE_PAGE_PAST,
  payload: page,
});

export const CHANGE_ROWS_PER_PAGE_PAST = `${prefix}/CHANGE_ROWS_PER_PAGE_PAST`;

export const changePastRowsPerPage = rowsPerPage => ({
  type: CHANGE_ROWS_PER_PAGE_PAST,
  payload: rowsPerPage,
});

export const CHANGE_HELP_SESSIONS_PAGE = `${prefix}/CHANGE_HELP_SESSIONS_PAGE`;

export const changeHelpSessionsPage = page => ({
  type: CHANGE_HELP_SESSIONS_PAGE,
  payload: page,
});

export const CHANGE_HELP_SESSIONS_ROWS_PER_PAGE = `${prefix}/CHANGE_HELP_SESSIONS_ROWS_PER_PAGE`;

export const changeHelpSessionsRowsPerPage = rowsPerPage => ({
  type: CHANGE_HELP_SESSIONS_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const CHANGE_HELP_SESSIONS_PAGE_PAST = `${prefix}/CHANGE_HELP_SESSIONS_PAGE_PAST`;

export const changePastHelpSessionsPage = page => ({
  type: CHANGE_HELP_SESSIONS_PAGE_PAST,
  payload: page,
});

export const CHANGE_HELP_SESSIONS_ROWS_PER_PAGE_PAST = `${prefix}/CHANGE_HELP_SESSIONS_ROWS_PER_PAGE_PAST`;

export const changePastHelpSessionsRowsPerPage = rowsPerPage => ({
  type: CHANGE_HELP_SESSIONS_ROWS_PER_PAGE_PAST,
  payload: rowsPerPage,
});

export const SET_END_MEETING_OPTIONS = `${prefix}/SET_END_MEETING_OPTIONS`;

export const setEndMeetingOptions = options => ({
  type: SET_END_MEETING_OPTIONS,
  payload: options,
});

export const FETCH_MEETING_INFORMATION = createRequestTypes(
  `${prefix}/FETCH_MEETING_INFORMATION`,
);

export const fetchMeetingInformation = makeApiActionCreatorV3(
  api.fetchMeetingInformation,
  FETCH_MEETING_INFORMATION[START],
  FETCH_MEETING_INFORMATION[SUCCESS],
  FETCH_MEETING_INFORMATION[ERROR],
);
